import { combineReducers } from 'redux'
import { routerMiddleware } from 'sb-connected-react-router'
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom'
import { batchedSubscribe } from 'redux-batched-subscribe'
import { createStore, combineReducers as redactionCombineReducers } from 'redaction'
import { createStoreEvents, reduxHookMiddleware } from 'sb-redux-hook'
import { createBrowserHistory } from 'history'
import localReducers from 'redux/reducers'
import routingReducer from 'redux/routing/reducer'
import type { Context } from 'sb-redux-hook/StoreContext'

import testInitialState from './testInitialState'
import sentryMiddleware from './sentryMiddleware'
import mixpanelMiddleware from './mixpanelMiddleware'


export default (initialState): Context => {
  const storeEvents = createStoreEvents(localReducers)
  const isClient    = process.env.WEBPACK === 'build.client' || process.env.WEBPACK === 'dev'
  const history     = isClient ? createBrowserHistory() : {}
  const devTools    = isClient && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (v) => v

  const middleware  = [
    routerMiddleware(history),
    reduxHookMiddleware(storeEvents),
    mixpanelMiddleware(),
  ]

  if (isClient) {
    window.__history__ = history
    middleware.push(sentryMiddleware())
  }

  const store = createStore({
    reducers: {
      misc: combineReducers(redactionCombineReducers(localReducers.misc)),
      view: combineReducers(redactionCombineReducers(localReducers.view)),
      models: combineReducers(redactionCombineReducers(localReducers.models)),
      routing: routingReducer,
    },
    middleware,
    enhancers: [
      devTools,
      batchedSubscribe(batchedUpdates),
    ],
    initialState,
  })

  testInitialState(store.getState())

  return { store, storeEvents }
}
